import { Component, ViewChild } from '@angular/core';
import { HeaderService } from '@app/core/services/header.service';
import { ODataService } from '@app/core/services/odata/odata.service';
import { SortParam } from '@app/core/constants/sort-param';
import { Observable } from 'rxjs';
import { ODataType } from '@app/core/services/odata/types/odata-type';
import { TableComponent } from '@shared/components/table/table.component';
import { TableConfig } from '@shared/interfaces/table/table-config';
import { dashboardColumns } from '@shared/columns/dashboard.columns';
import { odataTableConfig } from '@app/core/config/odata-table-config';

@Component({
  selector: 'app-dashboard-metering-point-quadrant-mismatch',
  imports: [
    TableComponent
  ],
  templateUrl: './dashboard-metering-point-quadrant-mismatch-component.html',
  styleUrl: './dashboard-metering-point-quadrant-mismatch-component.css'
})
export class DashboardMeteringPointQuadrantMismatchComponent {
  @ViewChild('table', { static: false }) public table?: TableComponent<any>;

  public tableConfig: TableConfig<any> = {
    id: 'table-dashboard-metering-point-quadrant-mismatch',
    columns: dashboardColumns,
    activeColumns: ['meteringPointIdentification', 'connectionPointIdentification', 'typeOfMeteringPoint', 'expectedQuadrant', 'quadrant', 'meterNumber'],
    ...odataTableConfig,
    selectable: false,
    fetchOnLoad: true,
    serviceCallback: (pageSize: number, page: number, order?: SortParam) => this.search(pageSize, page, order),
  }

  constructor(
    private readonly headerService: HeaderService,
    private readonly oDataService: ODataService,
  ) {
    this.headerService.setTitle('dashboard.query.querymeteringpointquadrantmismatch');
  }

  public search(pageSize: number, page: number, sort?: SortParam): Observable<any> {
    return this.oDataService.dmc.getPaginated(ODataType.meteringPointQuadrantMismatch, { pageSize, page, sort });
  }
}
